import { RootState } from 'types'
import { Action } from 'redux/actions'

export default function reduce(state: RootState['portal'] = { loaded: false }, action: Action): RootState['portal'] {
  switch (action.type) {
    case 'PORTAL_DATA_SET': {
      return {
        ...state,
        portalData: action.payload,
      }
    }

    case 'PORTAL_RESET': {
      return { loaded: false }
    }

    case 'PORTAL_EDIT_MODE_SET': {
      return {
        ...state,
        isEditMode: action.payload,
      }
    }

    case 'PORTAL_LOADED': {
      return {
        ...state,
        loaded: true,
      }
    }

    default:
      return state
  }
}
